<template>
	<div class="dialogue">
		<div class="dialogue__channels">
			<div
				v-for="(channel, i) in value"
				:key="key(i)"
				class="dialogue__channel"
			>
				<template v-for="(bubble, j) in channel">
					<SpeechInput
						:key="key(i, j)"
						:value="bubble"
						:removable="canRemove(i)"
						@input="value => update(i, j, value)"
						@delete="removeBubble(i, j)"
					/>
					<div
						:key="key(i, j, 'arrow')"
						v-if="showArrow(i, j)"
						class="dialogue__channel__arrow"
					>
						<IconNext />
					</div>
				</template>
				<div class="dialogue__channel__add" @click="addBubble(i)">
					<IconAdd />
				</div>
			</div>
			<div class="dialogue__channel">
				<div class="dialogue__channel__add" @click="addChannel">
					<IconAdd />
				</div>
			</div>
		</div>
		<p class="dialogue__info">
			One row of dialogue will be picked at random each time this event is
			triggered.<br />All bubbles in the row will be read out in the order they
			appear.
		</p>
	</div>
</template>

<script>
import SpeechInput from '@/components/admin/SpeechInput'
import IconAdd from 'mdi-vue/Plus'
import IconNext from 'mdi-vue/ArrowRight'

export default {
	name: 'DialogueEditor',
	props: {
		value: Array
	},
	data() {
		return { updater: 0 }
	},
	methods: {
		key(...args) {
			return [this.updater, ...args].join('_')
		},
		forceUpdate() {
			// Flip the update key every time something is removed
			this.updater = (this.updater + 1) % 2
		},
		clone() {
			return this.value ? this.value.map(a => [...a]) : []
		},
		showArrow(channel, bubble) {
			return bubble < this.value[channel].length - 1
		},
		addBubble(channel) {
			const dialogue = this.clone()
			dialogue[channel].push('')
			this.$emit('input', dialogue)
		},
		canRemove(channel) {
			// Disallow removing last bubble in a channel if only one channel
			return this.value.length > 1 || this.value[channel].length > 1
		},
		removeBubble(channel, bubble) {
			if (!this.canRemove(channel)) return false

			const dialogue = this.clone()
			if (dialogue[channel].length > 1) {
				// Remove the bubble
				dialogue[channel].splice(bubble, 1)
			} else {
				// Remove the channel
				dialogue.splice(channel, 1)
			}

			// Force re-render so input fields update correctly
			this.$emit('input', dialogue)
			this.forceUpdate()
		},
		addChannel() {
			const channel = ['']
			const dialogue = [...this.clone(), channel]
			this.$emit('input', dialogue)
		},
		update(channel, bubble, value) {
			const dialogue = this.clone()
			dialogue[channel][bubble] = value
			this.$emit('input', dialogue)
		}
	},
	components: {
		SpeechInput,
		IconAdd,
		IconNext
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/layout';
@import '~scss/components';

.dialogue {
	$gap: 1rem;
	$height: 4rem;
	@include truncate-margin;

	&__info {
		font-style: italic;
		font-size: 0.85rem;
		color: $grey-32;
	}

	&__channel {
		display: inline-flex;
		align-items: center;
		padding: $gap 0;
		background-color: $grey-95;
		width: calc(100% + #{$gap * 2});
		margin: 0 -1 * $gap;
		overflow-x: auto;

		&:not(:last-child) {
			margin-bottom: $gap;
		}

		> * {
			margin-left: $gap;
		}

		&__arrow {
			height: 1.5rem;
		}

		&__add {
			@include circle-button(1.5rem, $white, $grey-90);
			background-color: $white;
			&::after {
				@extend %pseudo;
				width: $gap;
				height: 100%;
				top: 0;
				left: 100%;
			}
		}
	}
}
</style>
